import NiceModal from '@ebay/nice-modal-react';

import { useCallback, useState } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import Button from 'components/field/Button';
import ConfirmationDialog from 'components/global/ConfirmationDialog';
import Icon from 'components/global/Icon';

import InternationalProforma from 'pages/Shipments/PrintOrders/InternationalProforma';
import PrintAWB from 'pages/Shipments/PrintOrders/PrintAWB';

import { faCircleNotch, faPrint, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { faCheck, faTimes } from '@fortawesome/pro-solid-svg-icons';

import * as S from './ActionColumn.styled';

const ActionColumn = ({ row, orders, setOrders, isReturnShipment, isSubmitting }) => {
	const [deleteButtonRef, setDeleteButtonRef] = useState(null);
	const isRemoveDisabled = orders.length <= 1;

	const formMethods = useFormContext();
	const { control } = formMethods;
	const { remove } = useFieldArray({
		control,
		name: 'items'
	});

	const handleRemoveOrder = useCallback(() => {
		const tempOrders = orders.filter((_, i) => i !== row.index);
		setOrders(tempOrders);
		remove(row.index);
	}, [orders]);

	const handlePrint = useCallback(() => {
		NiceModal.show(PrintAWB, {
			ids: [row.original.otoID],
			reverse: isReturnShipment
		}).then((resolved) => {
			if (isReturnShipment) return;

			const { internationalOrders = null } = resolved;

			if (internationalOrders?.length > 0) {
				NiceModal.show(InternationalProforma, {
					ids: internationalOrders
				});
			}
		});
	}, [row.original.otoID, isReturnShipment]);

	return (
		<S.Container>
			{row.original.shipmentID ? (
				<Button
					icon={faPrint}
					variant="transparent"
					color="var(--blue)"
					iconSize="medium"
					iconButton
					onClick={handlePrint}
				/>
			) : isSubmitting ? (
				<div
					style={{
						overflow: 'hidden'
					}}>
					<Icon icon={faCircleNotch} className="fa-spin" color="var(--blue)" />
				</div>
			) : (
				<>
					<Button
						ref={setDeleteButtonRef}
						icon={faTrashCan}
						variant="transparent"
						color="var(--red-70)"
						iconSize="medium"
						iconButton
						disabled={isRemoveDisabled}
					/>
					{!isRemoveDisabled && (
						<ConfirmationDialog
							buttonRef={deleteButtonRef}
							placement="bottom-end"
							title="confirmation.deleteItem"
							icon={faTrashCan}
							leftIcon={faTimes}
							rightLabel="yes"
							leftLabel="cancel"
							rightIcon={faCheck}
							rightAction={handleRemoveOrder}
						/>
					)}
				</>
			)}
		</S.Container>
	);
};

export default ActionColumn;
